import { IBookingConstraint } from "./Booking.types";
import { ISiteAdminTeam, ISiteAdminUser } from "./User.types";

export interface ISite {
    Id: number;
    Title: string;
    Address: string;
    PostCode: string;
    Description: string;
    SiteLevelParking: boolean;
    ParkingSpaces?: number;
    RestrictRoomAccess?: boolean;
    RestrictDeskAccess?: boolean;
    RoomAdminUsers?: number[];
    DeskAccessUsers?: number[];
    RoomAdminTeams?: number[];
    DeskAccessTeams?: number[];
    ResourceAdminUsers?: ISiteAdminUser[];
    ResourceAdminTeams?: ISiteAdminTeam[];
    DeskBookingConstraint?: IBookingConstraint;
    RoomBookingConstraint?: IBookingConstraint;
    Notes?: string;
    NotificationEmail?: string;
    RoomBookingEnabled?: boolean;
    DeskBookingEnabled?: boolean;
    WorkWeekOnly?: boolean;
    RoomCheckIns?: boolean;
}

export interface ILocation {
    Id: number;
    Title: string;
    BuildingNameNo: string;
    Floor: string;
    SiteId: number;
    RestrictRoomAccess?: boolean;
    RestrictDeskAccess?: boolean;
    ResourceAdminUsers?: ISiteAdminUser[];
    DeskBookingConstraint?: IBookingConstraint;
    RoomBookingConstraint?: IBookingConstraint;
    RoomCheckIns?: boolean;
}

export interface IRoom {
    Id: number;
    Name: string;
    Capacity?: number;
    Equipment?: string;
    SiteId: number;
    LocationId: number;
    SiteName: string;
    LocationName: string;
    IsRestricted?: boolean;
    IsRoomAdmin?: boolean;
    Disabled?: boolean;
    Hidden?: boolean;
    RestrictRoomAccess?: boolean;
    ResourceAdminUsers?: ISiteAdminUser[];
    RoomBookingConstraint?: IBookingConstraint;
    RoomCheckIns?: boolean;
    RoomType?: RoomType;
    RoomAvailability?: IRoomAvailabilitySlot[];
}

export enum RoomType {
    MeetingRoom = 0,
    Clinical = 1
}

export interface IRoomAvailabilitySlot {
    key: string;
    Id?: number;
    Day: number;
    TimeStart: string;
    TimeEnd: string;
    EffectiveFrom: Date;
    EffectiveTo?: Date;
}

export interface IFloorplan {
    Id: string;
    LocationId: number;
    Name: string;
    LoadAsDefault: boolean;
    FloorplanLayout?: IFloorplanLayout;
}

export interface IFloorplanLayout {
    Id: number;
    FloorplanId: string;
    Json: string;
    Published: boolean;
    DateValid: string;
    DateAdded: string;
    DateModified: string;
}

export interface IPublishedFloorplanLayout extends IFloorplanLayout {
    HasParking: boolean;
    ParkingLimit: number;
    FloorplanName: string;
    LocationBuildingNo: string;
    LocationName: string;
    SiteNotes: string;
}

export interface IFloorplanAddResult {
    floorplanId: string;
    layoutId: number;
}

